import { useTranslation } from '@eti/providers';
import {
  ADDED_CABIN_BAGGAGE,
  INCLUDED_AND_ADDED_CABIN_BAGGAGE,
  INFANT_NO_CABIN_BAGGAGE,
  NO_CABIN_BAGGAGE,
} from '../../../constants/includedBaggageConstants';
import { resolveCabinBaggageForTraveler } from '../../../widgets/cart/utils/baggage';

export const checkSummariesFor = (status, summaries = []) =>
  summaries.some((traveler) => traveler.cabinBaggageStatus === status);

const useAddedCabinBaggage = (travelers, cabinBaggageTripSummary = {}) => {
  const { t } = useTranslation();
  const { cabinBaggageTravelerDetails } = cabinBaggageTripSummary;
  const hasCabinBaggageBeenAddedToTrip = checkSummariesFor(
    ADDED_CABIN_BAGGAGE,
    cabinBaggageTravelerDetails,
  );
  const isCabinBaggageIncludedOrAddedOnTrip = checkSummariesFor(
    INCLUDED_AND_ADDED_CABIN_BAGGAGE,
    cabinBaggageTravelerDetails,
  );

  const notSelectedLabel = t('Cart.CabinBaggage.Placeholder');

  if (!hasCabinBaggageBeenAddedToTrip && !isCabinBaggageIncludedOrAddedOnTrip) {
    return [{ label: notSelectedLabel, noBaggageSelected: true }];
  }

  if (hasCabinBaggageBeenAddedToTrip || isCabinBaggageIncludedOrAddedOnTrip) {
    return travelers.map((traveler) => {
      const travelerBaggageSummary = cabinBaggageTravelerDetails.find(
        (summary) => summary.travelerId === traveler.id,
      );

      if (travelerBaggageSummary.cabinBaggageStatus === NO_CABIN_BAGGAGE) {
        return {
          label: traveler.name,
          value: notSelectedLabel,
        };
      }

      if (travelerBaggageSummary.cabinBaggageStatus === INFANT_NO_CABIN_BAGGAGE) {
        return {
          label: traveler.name,
          value: t('Cart.CabinBaggage.ContactAirline'),
        };
      }

      return {
        label: traveler.name,
        value: resolveCabinBaggageForTraveler(t, travelerBaggageSummary?.cabinBaggageDetails),
      };
    });
  }
  return null;
};

export default useAddedCabinBaggage;
